<!-- Step1 基本情報 -->
<template>
  <div class="egl-dialog-elm">
    <el-dialog
      :visible="isOpen"
      :title="$locale('dailyClosing.createDialog.title')"
      width="90%"
      class="egl-dialog create-daily-closing-dialog"
      :modal="false"
      :show-close="true"
      :close-on-click-modal="false"
      @close="closeAction"
    >
      <el-form :disabled="isDetailMode" :model="detailData" label-position="top">
        <div class="module-item">
          <!-- 基本情報 -->
          <h2>{{ $locale("dailyClosing.createDialog.basicInfo.title") }}</h2>
          <el-row :gutter="10">
            <el-col :span="5">
              <el-form-item :label="$locale('dailyClosing.createDialog.basicInfo.date')" :required="true">
                <CommDatePicker
                  v-model="detailData.dayCloseDate"
                  :value.sync="detailData.dayCloseDate"
                  :placeholder="$locale('setting.emergency.p.stoptime')"
                  width="100%"
                  :showWeekly="true"
                  :disabled="isDetailMode"
                  :pickerOptions="disDate"
                />
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item :label="$locale('dailyClosing.createDialog.basicInfo.weather')">
                <el-select
                  v-model="detailData.weather"
                  :placeholder="$locale('dailyClosing.createDialog.basicInfo.weather.placeHolder')"
                  :disabled="isDetailMode"
                >
                  <el-option
                    v-for="item in weatherList"
                    :key="item.key"
                    :label="item.lable"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="4">
              <el-form-item>
                <el-button
                  class="egl-btn-yellow btn-search-submit"
                  :disabled="isDetailMode"
                  @click="changeDateNWeather"
                >
                  {{ $locale("dailyClosing.createDialog.basicInfo.submit") }}
                </el-button>
              </el-form-item>
            </el-col> -->
          </el-row>
          <hr class="dotted">

          <!-- 対象レジ（シフト）の選択 -->
          <div class="module-item-tit">{{ $locale("dailyClosing.createDialog.targetRegistrationRecordTable.title") }}</div>
          <el-table
            ref="targetRegistrationRecordTable"
            class="egl-table targetRegistrationRecordTable"
            :data="isDetailMode ? detailShiftList : shiftList"
            @select="selectAction"
            @select-all="selectAction"
          >
            <el-table-column
              v-if="shiftList.length > 0"
              label=""
              width="80"
              type="selection"
            ></el-table-column>
            <el-table-column
              :label="$locale('dailyClosing.createDialog.targetRegistrationRecordTable.th.deviceName')"
              prop="deviceName"
            ></el-table-column>
            <el-table-column
              :label="$locale('dailyClosing.createDialog.targetRegistrationRecordTable.th.deviceType')"
              prop="deviceType"
            ></el-table-column>
            <el-table-column
              :label="$locale('dailyClosing.createDialog.targetRegistrationRecordTable.th.closeUserName')"
              prop="closeUserName"
            ></el-table-column>
            <el-table-column
              :label="$locale('dailyClosing.createDialog.targetRegistrationRecordTable.th.operatingTime')"
              prop="openTime"
            >
              <template slot-scope="scope">
                {{ $moment(scope.row.openTime).format("YYYY/MM/DD") + ' - ' + $moment(scope.row.closeTime).format("YYYY/MM/DD") }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$locale('global.control')"
              width="150"
              align="center"
            >
              <template slot-scope="scope">
                <div class="handle">
                  <a @click="toggleDetail(scope.row.id)">
                    {{ $locale("global.detail") }}
                  </a>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- <hr class="dotted"> -->

          <!-- 売掛金現金回収の登録 -->
          <div class="module-item-tit">{{ $locale("dailyClosing.createDialog.accountsReceivableCashCollectionRegistrationTable.title") }}</div>
          <AccReceivableCashReg
            :sellList="sellList"
            :clientList="injectClientList"
            :tableData.sync="detailData.accountsRecovery"
          ></AccReceivableCashReg>
          <hr class="dotted">

          <!-- その他営業収入の現金回収の登録 -->
          <div class="module-item-tit">{{ $locale("dailyClosing.createDialog.otherCashCollectionRegistrationTable.title") }}</div>
          <OtherCashRevenueReg
            :otherRevList="otherRevList"
            :clientList="injectClientList"
            :tableData="detailData.otherCashRecovery"
            v-bind="$attrs"
            v-on="$listeners"
            :isOpen="isOpen"
          ></OtherCashRevenueReg>
          <hr class="dotted">

          <!-- 買掛金現金支払の登録 -->
          <div class="module-item-tit">{{ $locale("dailyClosing.createDialog.accountsPayableCashPaymentRegistrationTable.title") }}</div>
          <AccPayableCashPaymentReg
            :paymentList="paymentList"
            :clientList="injectClientList"
            :tableData.sync="detailData.accountsPayment"
          ></AccPayableCashPaymentReg>
          <hr class="dotted">

          <!-- その他仕入の現金支払の登録 -->
          <div class="module-item-tit">{{ $locale("dailyClosing.createDialog.otherCashPaymentRegistrationTable.title") }}</div>
          <OtherCashPaymentReg
            :otherGoodsList="otherGoodsList"
            :clientList="injectClientList"
            :tableData="detailData.otherCashPayment"
            v-bind="$attrs"
            v-on="$listeners"
            :isOpen="isOpen"
          ></OtherCashPaymentReg>
          <hr class="dotted">
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button
          class="egl-btn-white"
          @click="closeAction(false)"
        >{{ $locale("global.cancel") }}</el-button>
        <el-button
          :class="nextBtnDisabled ? 'egl-btn-gray' : 'egl-btn-yellow'"
          :disabled="nextBtnDisabled"
          @click="next_fn"
        >{{ $locale("dailyClosing.createDialog.basicInfo.next") }}</el-button>
      </div>
    </el-dialog>

    <CashierReportDetail
      :dialogVisible="showDetailDialog"
      :shiftType="shiftType"
      :actualCashTitle="actualCashTitle"
      :shiftDetail="shiftDetail"
      @closeFn="backToShiftList"
      class="cashierTable"
    ></CashierReportDetail>
  </div>
</template>

<script>
import { mapState } from "vuex";
import tranfResData from "@/utils/tranfResData";
import { checkValidData } from "@/utils/common";
import CommDatePicker from "@/components/common/CommDatePicker";

import { submitDailyClosingBasic } from "@/helpers/service/api/dailyClosingNew";
import { getShiftDetail } from "@/helpers/service/api/cashierReport";
import { weatherList } from "@/assets/js/dailyClosingNew";
import { shiftReportDetailDataMassage } from "@/assets/js/cashierReport";
import AccReceivableCashReg from "./AccReceivableCashReg";
import OtherCashRevenueReg from "./OtherCashRevenueReg";
import AccPayableCashPaymentReg from "./AccPayableCashPaymentReg";
import OtherCashPaymentReg from "./OtherCashPaymentReg";
import CashierReportDetail from "@/components/CashierReport/CashierReportDetail";

export default {
  name: "BasicInfo",
  inject: [ "clientList" ],
  components: {
    CommDatePicker,
    AccReceivableCashReg,
    OtherCashRevenueReg,
    AccPayableCashPaymentReg,
    OtherCashPaymentReg,
    CashierReportDetail,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    actionType: {
      type: String,
      default: null,
    },
    shiftList: {
      type: Array,
      default: () => [],
    },
    otherRevList: {
      type: Array,
      default: () => [],
    },
    otherGoodsList: {
      type: Array,
      default: () => [],
    },
    sellList: {
      type: Array,
      default: () => [],
    },
    paymentList: {
      type: Array,
      default: () => [],
    },
    cinemaList: {
      type: Array,
      default: () => []
    },
    // clientList: {
    //   type: Array,
    //   default: () => []
    // },
    detailData: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      disDate: {
        disabledDate: this.disDate_fn
      },
      weatherList,
      // for detail dailog
      shiftType: false,
      showDetailDialog: false,
      actualCashTitle: "",
      shiftDetail: {},
      originalShiftList: [],
    };
  },
  computed: {
    ...mapState("app", {
      cinemaId: state => state.cinemaId,
    }),
    isDetailMode() {
      return this.actionType === "detail";
    },
    nextBtnDisabled() {
      let _nextBtnDisabled = false;
      const { dayCloseDate, shifts } = this.detailData;
      if (!dayCloseDate || shifts.length === 0) {
        _nextBtnDisabled = true;
      }
      return _nextBtnDisabled;
    },
    detailShiftList() {
      let _targetArray = [];
      if (this.isDetailMode && this.originalShiftList.length > 0 && this.shiftList.length > 0) {
        _targetArray = this.shiftList.filter(_list => this.originalShiftList.includes(_list.id));
      }
      return _targetArray;
    },
    isOpen: {
      get() {
        return this.visible;
      },
      set() {
        return !this.visible;
      },
    },
    injectClientList() {
      return this.clientList();
    },
  },
  watch: {
    visible(_nv) {
      if (_nv === true) {
        this.originalShiftList = tranfResData(this.detailData.shifts);

        this.$nextTick(() => {
          this.autoSelectTableItemsFn();
        });

        // Set weather to null, if API return "0"
        if (this.detailData.weather === 0) {
          this.detailData.weather = null;
        }
      }
    },
    shiftList(_nv) {
      if (_nv && _nv.length > 0) {
        this.$nextTick(() => {
          this.autoSelectTableItemsFn();
        });
      }
    },
  },
  methods: {
    closeAction(_goNextStep = false) {
      this.$emit("closeDialogFn", {
        name: "step1",
        nextStep: _goNextStep,
        prevStep: false,
      });
    },
    autoSelectTableItemsFn() {
      const _table = this.$refs.targetRegistrationRecordTable;

      if (this.actionType === "create" || this.isDetailMode) {
        _table.toggleAllSelection();
      } else if (this.shiftList.length > 0 && this.originalShiftList.length > 0) {
        const _shiftListData = tranfResData(this.shiftList);

        this.originalShiftList.forEach(_shiftId => {
          _shiftListData.forEach(_shiftData => {
            if ((_shiftData.id).includes(_shiftId)) {
              _shiftData.selected = true;
            }
          });
        });

        const _selectedShiftData = _shiftListData.filter(_shiftData => _shiftData.selected);

        _selectedShiftData.forEach(_selectedItem => {
          const _targetIdx = this.shiftList.findIndex(_shift => _shift.id === _selectedItem.id);

          if (_targetIdx > -1) {
            _table.toggleRowSelection(_table.data[_targetIdx], true);
          }
        });
        this.tableSelect(_selectedShiftData);

      } else if (this.$refs.targetRegistrationRecordTable) {
        this.$refs.targetRegistrationRecordTable.clearSelection();
      }
    },
    selectAction(selection, row) {
      /**
       * NOTICE: shift list table NEED SPECIAL selection handling!
       * WHEN user checked one item, need to AUTO select all items ABOVE this current item
       * WHEN user unchecked one item, need to AUTO clear all items BELOW this current item
       */

      let _selection = [];

      if (row) {
        let _selected = false;
        const _table = this.$refs.targetRegistrationRecordTable;
        const { id: checkedId } = row;

        if (selection.length > 0 && selection.find(__row => __row.id === checkedId)) {
          _selected = true;
        }

        const _targetIdx = _table.data.findIndex(_shift => _shift.id === checkedId);
        _selection = [ ...selection ];

        if (_selected) {
          for (let i = 0; i <= _targetIdx; i++) {
            if (!_selection.find(_shift => _shift.id === _table.data[i].id)) {
              _selection.push(_table.data[i]);
              _table.toggleRowSelection(_table.data[i], true);
            }
          }
        } else {
          for (let i = _targetIdx; i < _table.data.length; i++) {
            _table.toggleRowSelection(_table.data[i], false);
          }

          _selection = [ ..._table.data ].slice(0, _targetIdx);
        }
      } else {
        _selection = [ ...selection ];
      }

      this.tableSelect(_selection);
    },
    tableSelect(selection) {
      if (selection.length > 0) {
        this.detailData.shifts = [ ...selection ].map(_data => _data.id);
      } else {
        this.detailData.shifts = [];
      }
    },
    openShiftDetailDialog() {
      this.showDetailDialog = true;
    },
    toggleDetail(id) {
      getShiftDetail({ shiftId: id }, true).then(res => {
        let tableData = shiftReportDetailDataMassage(res.data, this.shiftType);
        if (tableData.deviceType !== "POS" && this.shiftType) {
          const currentTime = this.$moment().format("YYYY/MM/DD HH:mm:ss");
          this.actualCashTitle = `${this.$locale("cashierReport.dialog.closingCashTypeTable")} (${this.$locale("cashierReport.dialog.currentTime")} ${currentTime})`;
        } else {
          this.actualCashTitle = this.$locale("cashierReport.dialog.closingCashTypeTable");
        }
        this.shiftDetail = tableData;
        this.openShiftDetailDialog();
      });
    },
    backToShiftList() {
      this.showDetailDialog = false;
    },
    changeDateNWeather() {
      this.$emit("getDailyClosingShiftList");
    },
    next_fn() {
      if (this.isDetailMode) {
        this.closeAction(true);
      } else {
        const {
          accountsPayment,
          accountsRecovery,
          dayCloseDate,
          id,
          otherCashPayment,
          otherCashRecovery,
          shifts,
          weather,
        } = tranfResData(this.detailData);

        let requestParam = {
          cinemaId: this.cinemaId,
          accountsPayment,
          accountsRecovery,
          dayCloseDate,
          id,
          otherCashPayment,
          otherCashRecovery,
          shifts,
          weather: weather === null ? 0 : weather,
        };

        /** NOTICE: special handling for "dayCloseDate",
         * if dayCloseDate is TODAY, TIME as CURRENT TIME,
         * if dayCloseDate is BEFORE TODAY, TIME need to set to 3PM
         * */

        const _today = this.$moment().valueOf();
        if (this.$moment(dayCloseDate).isBefore(_today, "day")) {
          requestParam.dayCloseDate = this.$moment(dayCloseDate).startOf("day").add(15, "hours").valueOf();
        }

        /* need to remove empty list */
        requestParam.accountsPayment.forEach(_ap => {
          delete _ap.currentPaymentIndex;
          const _isValidData = checkValidData(_ap);
          _ap.isValidData = _isValidData;
        });
        requestParam.accountsPayment = requestParam.accountsPayment.filter(_ap => _ap.isValidData);

        requestParam.accountsRecovery.forEach(_ar => {
          delete _ar.currentSellIndex;
          const _isValidData = checkValidData(_ar);
          _ar.isValidData = _isValidData;
        });
        requestParam.accountsRecovery = requestParam.accountsRecovery.filter(_ar => _ar.isValidData);

        requestParam.otherCashPayment.forEach(_ocp => {
          const _isValidData = checkValidData(_ocp);
          _ocp.isValidData = _isValidData;
        });
        requestParam.otherCashPayment = requestParam.otherCashPayment.filter(_ocp => _ocp.isValidData);

        requestParam.otherCashRecovery.forEach(_ocr => {
          const _isValidData = checkValidData(_ocr);
          _ocr.isValidData = _isValidData;
        });
        requestParam.otherCashRecovery = requestParam.otherCashRecovery.filter(_ocr => _ocr.isValidData);

        submitDailyClosingBasic(requestParam).then(res => {
          if (res.success) {
          // NOTICE: basic API returns data NOT include "bankAccountId"
            const _resData = res.data ? tranfResData(res.data) : {};
            const { amountCalculationInfo: _existAmountCalculationInfo } = this.detailData;
            const { bankAccountId: _existBankAccountId } = _existAmountCalculationInfo;

            const _amountCalculationInfo = {
              create: _resData,
              edit: {
                ..._resData,
                bankAccountId: _existBankAccountId,
              },
              detail: {
                ..._existAmountCalculationInfo,
                bankAccountId: _existBankAccountId,
              },
            };

            this.$emit("update:detailData", {
              ...this.detailData,
              amountCalculationInfo: _amountCalculationInfo[this.actionType],
            });

            this.closeAction(true);
          }
        });

        // submitDailyClosingBasic(requestData).then(res => {

        // this.$emit("nextFn", "createRecord", "cashTable");

        // this.$emit("updateNextDialogData", "cashTable", { ...res.data, bankAccountId: this.actionType !== "create" ? this.bankId : "" });
        // });

        // const brandId = window.localStorage.getItem("brandId");
        // let obj = JSON.parse(JSON.stringify(this.formData));
        // let tableData = this.$refs.otherTable.getOtherPurchase();

        // obj.targetSourceList.elseBuy = tableData.data;
        // obj.brandId = brandId;

        // if (!obj.id) {
        //   createAccountPayable(obj).then(res => {
        //     if (res.success) {
        //       this.$emit("closeFn");
        //       this.$emit("refreshTable");
        //     }
        //   });
        // } else {
        //   updateAccountPayable(obj).then(res => {
        //     if (res.success) {
        //       this.$emit("closeFn");
        //       this.$emit("refreshTable", this.$locale("global.updateSuccessfully"));
        //     }
        //   });
        // }
      }
    },
    disDate_fn(time) {
      return time.getTime() > this.$moment().valueOf();
    },
  },
  inheritAttrs: true
};
</script>

<style scoped>
  .btn-search-submit {
    margin-top: 40px;
  }
</style>

